/**
 * 歌词高亮主题样式（固定枚举，避免 Tailwind 动态类被 purge）
 */

export const getHighlightThemeClasses = (highlightTheme) => {
  switch (highlightTheme) {
    case 'cyan':
      return {
        text: 'text-cyan-200',
        bg: 'bg-gradient-to-r from-cyan-500/20 via-cyan-400/10 to-transparent',
        ring: 'ring-1 ring-cyan-400/25',
        miniBorder: 'border-cyan-400/20',
        miniText: 'text-cyan-100',
        miniTrans: 'text-cyan-100/70',
        glowRGB: '34,211,238' // cyan-400
      };
    case 'green':
      return {
        text: 'text-emerald-200',
        bg: 'bg-gradient-to-r from-emerald-500/20 via-emerald-400/10 to-transparent',
        ring: 'ring-1 ring-emerald-400/25',
        miniBorder: 'border-emerald-400/20',
        miniText: 'text-emerald-100',
        miniTrans: 'text-emerald-100/70',
        glowRGB: '52,211,153' // emerald-400
      };
    case 'purple':
      return {
        text: 'text-fuchsia-200',
        bg: 'bg-gradient-to-r from-fuchsia-500/18 via-purple-500/10 to-transparent',
        ring: 'ring-1 ring-fuchsia-400/25',
        miniBorder: 'border-fuchsia-400/20',
        miniText: 'text-fuchsia-100',
        miniTrans: 'text-fuchsia-100/70',
        glowRGB: '232,121,249' // fuchsia-400
      };
    case 'amber':
    default:
      return {
        text: 'text-amber-200',
        bg: 'bg-gradient-to-r from-amber-500/20 via-amber-400/10 to-transparent',
        ring: 'ring-1 ring-amber-400/25',
        miniBorder: 'border-amber-400/20',
        miniText: 'text-amber-200',
        miniTrans: 'text-amber-100/70',
        glowRGB: '251,191,36' // amber-400
      };
  }
};

export const getGlowAlpha = (highlightGlow) => {
  switch (highlightGlow) {
    case 'low':
      return 0.18;
    case 'high':
      return 0.42;
    case 'medium':
    default:
      return 0.28;
  }
};
